<template>
  <div class="drag" ref="dragDiv" @mousedown="onDragStart" @touchstart="onDragStart">
    <div class="drag_bg" ref="dragBg"></div>
    <div class="drag_text" ref="dragText">{{ confirmWords }}</div>
    <div ref="moveDiv" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg"></div>
  </div>
</template>

<script>
  export default {
    name: 'Slider',
    data() {
      return {
        beginClientX: 0,
        /* 距离屏幕左端距离 */
        mouseMoveStata: false,
        /* 触发拖动状态  判断 */
        touching: false,
        /* 当前这次是手指拖动，用来丢掉紧跟其后的模拟鼠标事件 */
        maxwidth: '',
        /* 拖动最大宽度，依据滑块宽度算出来的 */
        confirmWords: '拖动滑块验证',
        /* 滑块文字 */
        confirmSuccess: false /* 验证成功判断 */
      }
    },
    methods: {
      isSuccess() {
        return this.confirmSuccess
      },
      // 鼠标用 clientX，手指用 touches / changedTouches
      getClientX(e) {
        if (e.touches && e.touches.length) return e.touches[0].clientX
        if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX
        return e.clientX
      },
      // 按下滑块或滑轨开始拖动
      onDragStart(e) {
        if (this.confirmSuccess) return
        // 手指按下后浏览器还会补发 mousedown，忽略避免重复起拖
        if (e.type === 'mousedown' && this.touching) return
        const clientX = this.getClientX(e)
        if (clientX == null) return
        this.touching = e.type === 'touchstart'
        // 阻止页面跟着手指横滑，否则移动端滑块不会动
        if (this.touching && e.cancelable) e.preventDefault()
        this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
        if (this.maxwidth <= 0) return
        this.mouseMoveStata = true
        this.beginClientX = clientX
      },
      successFunction() {
        this.confirmSuccess = true
        this.confirmWords = '验证通过'
        this.mouseMoveStata = false
        this.touching = false
        this.unbindDragEvents()
        this.$refs.dragText.style.color = '#fff'
        this.setOffset(this.maxwidth)
        this.$emit('onSuccess', true)
      },
      // 拖动过程中按位移更新滑块
      onDragMove(e) {
        if (!this.mouseMoveStata) return
        if (e.type === 'mousemove' && this.touching) return
        if (e.type === 'touchmove' && e.cancelable) e.preventDefault()
        const clientX = this.getClientX(e)
        if (clientX == null) return
        const width = clientX - this.beginClientX
        if (width > 0 && width <= this.maxwidth) {
          this.setOffset(width)
        } else if (width > this.maxwidth) {
          this.successFunction()
        }
      },
      // 松手未拖到头则滑块回弹
      onDragEnd(e) {
        if (e.type === 'mouseup' && this.touching) return
        if (!this.mouseMoveStata) return
        this.mouseMoveStata = false
        this.touching = false
        if (this.confirmSuccess) return
        const clientX = this.getClientX(e)
        const width = (clientX == null ? 0 : clientX) - this.beginClientX
        if (width < this.maxwidth) this.setOffset(0)
      },
      // 同步滑块位置和已滑过的绿色条
      setOffset(px) {
        const val = px + 'px'
        this.$refs.moveDiv.style.left = val
        this.$refs.dragBg.style.width = val
      },
      // 在页面上监听移动和松手，手指拖出滑块区域也能继续
      bindDragEvents() {
        const root = document.documentElement
        root.addEventListener('mousemove', this.onDragMove)
        root.addEventListener('mouseup', this.onDragEnd)
        // 文档级 touchmove 默认是 passive，不声明 false 就无法 preventDefault
        root.addEventListener('touchmove', this.onDragMove, { passive: false })
        root.addEventListener('touchend', this.onDragEnd)
        root.addEventListener('touchcancel', this.onDragEnd)
      },
      unbindDragEvents() {
        const root = document.documentElement
        root.removeEventListener('mousemove', this.onDragMove)
        root.removeEventListener('mouseup', this.onDragEnd)
        root.removeEventListener('touchmove', this.onDragMove)
        root.removeEventListener('touchend', this.onDragEnd)
        root.removeEventListener('touchcancel', this.onDragEnd)
      }
    },
    mounted() {
      this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
      this.bindDragEvents()
    },
    beforeDestroy() {
      this.unbindDragEvents()
    }
  }
</script>

<style scoped>
  .drag {
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: center;
    /* 这一条交给组件自己处理，避免手机把横滑当成页面滚动 */
    touch-action: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .handler {
    width: 40px;
    height: 34px;
    border: 0.5px solid #ccc;
    cursor: move;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    touch-action: none;
  }

  .handler_bg {
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
  }

  .handler_ok_bg {
    background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==") no-repeat center;
  }

  .drag_bg {
    background-color: #7ac23c;
    height: 34px;
    width: 0px;
  }

  .drag_text {
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    z-index: 1;
    /* 文案不拦触摸，手指按在字上也能拖 */
    pointer-events: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/slider.vue